import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["textarea", "gutter"];

  connect() {
    this.updateLineNumbers();
    this.syncScroll();
  }

  updated() {
    this.updateLineNumbers();
  }

  scrolled() {
    this.syncScroll();
  }

  updateLineNumbers() {
    const lines = this.textareaTarget.value.split("\n").length;
    const numbers = Array.from({ length: lines }, (_, i) => i + 1).join("\n");
    this.gutterTarget.textContent = numbers;
  }

  syncScroll() {
    this.gutterTarget.scrollTop = this.textareaTarget.scrollTop;
  }
}
